import LocalStorage from './myLocalStorage'

// My Little Storage (global storage)
let LS = {}

const TOKEN_CSRF = 'csrfToken'

const clear = () => {
  console.debug('Clearing little-storage (csrf-token deleted)')
  LS = {}
}

/**
 *
 * Note: values are stored under tabKeys as String (retrieved as such from backend storage)
 * @param {*} tabKeys
 * @param {*} valueType
 * @param {*} defaultValue value returned in its expected <valueType>. If valueType is NOT_FOUND, returns undefined instead (no value)
 */
const getOrDefault = (tabKeys, valueType, defaultValue) => {
  // Default value to return
  let valueToReturn = valueType !== LocalStorage.VALUE_TYPE.NOT_FOUND ? defaultValue : LocalStorage.VALUE_TYPE.NOT_FOUND

  if (tabKeys.length > 0) {
    // Check 1st key is in LS
    let LS_valueForSeqKeys = LS[tabKeys[0]]

    for (let i = 1; i < tabKeys.length && LS_valueForSeqKeys !== undefined; i++) {
      const aKey = tabKeys[i]
      LS_valueForSeqKeys = LS_valueForSeqKeys[aKey]
    }

    if (LS_valueForSeqKeys !== undefined) {
      // Get value stored and convert it into desired valueType
      switch (valueType) {
        case LocalStorage.VALUE_TYPE.BOOLEAN:
          valueToReturn = LS_valueForSeqKeys === 'true'
          break
        case LocalStorage.VALUE_TYPE.INTEGER:
          valueToReturn = parseInt(LS_valueForSeqKeys)
          break
        case LocalStorage.VALUE_TYPE.STRING:
          valueToReturn = LS_valueForSeqKeys
          break
        case LocalStorage.VALUE_TYPE.OBJECT:
          valueToReturn = LS_valueForSeqKeys
          break
        default:
          break
      }
    }
  }

  return valueToReturn
}

/**
 * In order to put a stringValue at the bottom of a tabKeys sequence within the littleStorage,
 * we proceed following 2 steps:
 * - 1st step: browsing in sequence each key after another as long as it is found. We stop this step when a key is not found and breaks the sequence
 * - 2nd step: for all remaining keys of the sequence, we add then sequencely starting at the point we broke at previous step
 * Finally we put the stringValue at the desired sequence-depth.
 * @param {} tabKeys
 * @param {*} objectValue
 */
const put = (tabKeys, objectValue) => {
  if (tabKeys.length > 0) {
    let indx = 0
    let LScurrentValue
    let keyFound
    if (LS.hasOwnProperty(tabKeys[indx])) {
      // Key is present =>
      // - if value is a string, then point to its key since we will break here and go further with next step;
      // - otherwise if value is an object, then point onto this object to go further with next key
      const valueToStore = LS[tabKeys[indx]]
      if (typeof valueToStore === 'object' && valueToStore !== null) {
        LScurrentValue = LS[tabKeys[indx]]
      } else {
        LScurrentValue = LS
      }
      keyFound = true
      // We'll go further with next key
      indx++
    } else {
      LScurrentValue = LS
      keyFound = false
    }

    // Step -1-
    while (indx < tabKeys.length - 1 && keyFound) {
      const currentKey = tabKeys[indx]
      if (LScurrentValue.hasOwnProperty(currentKey)) {
        LScurrentValue = LScurrentValue[currentKey]
        indx++
      } else {
        keyFound = false
      }
    }

    // Step -2-
    if (keyFound) {
      // Finally we put our stringValue staff there
      LScurrentValue[tabKeys[tabKeys.length - 1]] = objectValue
    } else {
      for (let indx2 = indx; indx2 < tabKeys.length - 1; indx2++) {
        // Creation of empty object attched to current key
        LScurrentValue[tabKeys[indx2]] = {}
        // Entering this object in order to create further sub-keys
        LScurrentValue = LScurrentValue[tabKeys[indx2]]
      }
      // Finally we put our stringValue staff there
      LScurrentValue[tabKeys[tabKeys.length - 1]] = objectValue
    }
  }
}

const contains = (tabKeys) => {
  let isKeysFound = true
  if (tabKeys.length > 0) {
    // Check 1st key is in LS
    let LS_seqKeys = LS[tabKeys[0]]

    for (let i = 1; i < tabKeys.length && LS_seqKeys !== undefined; i++) {
      const aKey = tabKeys[i]
      LS_seqKeys = LS_seqKeys[aKey]
    }
    isKeysFound = LS_seqKeys !== undefined
  }

  return isKeysFound
}

const remove = (key1stLevel) => {
  if (LS.hasOwnProperty(key1stLevel)) {
    delete LS[key1stLevel]
  }
}

export default { TOKEN_CSRF, clear, getOrDefault, put, contains, remove }
